import { makeStyles } from '@material-ui/core';

const useMFAStyles = makeStyles((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');
  return ({
    wrapper: {
      padding: '48px 36px 48px 36px',
      display: 'flex',
      flexDirection: 'column',
      [mobileBreakpoint]: {
        boxShadow: 'none',
        width: '100%',
        padding: '0px'
      },
    },
    canNotVerifyWrapper: {
      maxWidth: '610px'
    },
    resendCodeWrapper: {
      display: 'flex',
      alignItems: 'center',
      color: 'var(--fire-red) !important',
      lineHeight: '2',
      fontSize: 'var(--button-text-size)',
    },
    mfaLabel: {
      fontWeight: 500,
      color: 'var(--neutrals-black)'
    },
    mfaPhoneLabel: {
      fontWeight: 700
    },
    otpInput: {
        width: '65px !important',
        height: '45px !important',
        margin: '0 5px',
        fontSize: 18,
        border: '1px solid var(--pale-grey)',
        fontFamily: 'roboto',
        [mobileBreakpoint]: {
          width: '46px !important',
          height: '40px !important',
          margin: '0 12px',
        },

        '& :focus' : {
          outline: 'none',
          borderColor: 'var(--azure)',
        }
    },
    otpInputFocus: {
      outline: 'none',
      borderColor: 'var(--azure)',
    },
    otpInputContainer: {
      '& :first-child input': {
        marginLeft: 0
      },
      '& :last-child input': {
        marginRight: 0
      },
    },
    otpError: {
      borderColor: 'var(--light-venetian-red)'
    },
    linkButton: {  
      lineHeight: '2',
      fontSize: '16px',
      "&[disabled]": {
        color: "grey",
        cursor: "default",
        "&:hover": {
          textDecoration: "none"
        }
      },
    },
    resendButton: {  
      lineHeight: '2',
      fontSize: 16,
      fontFamily: 'roboto',
      color: '#007DB8',
      "&[disabled]": {
        color: "#9B9B9B",
        cursor: "default",
        "&:hover": {
          textDecoration: "none"
        }
      },
    },
    title: {
      fontSize: 30
    },
    emailSupport: {
      color: 'var(--teal-blue)',
      fontWeight: 500
    }
  });
});

export default useMFAStyles;
